import { api } from 'app/config/apiConfig';
import { Contract } from '../model/types';

export const updateContractAccessApi = api.injectEndpoints({
  endpoints: (builder) => ({
    updateContractAccess: builder.mutation<Contract, { contractId: string; accessDenied: boolean }>({
      query: (args) => ({
        url: `/contracts/${args.contractId}/access`,
        method: 'PUT',
        body: { accessDenied: args.accessDenied },
      }),
      invalidatesTags: ['Contracts', 'Contract details', 'My bookings'],
    }),
  }),
});

export const { useUpdateContractAccessMutation } = updateContractAccessApi;
